import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import getContentType from '../utils/getContentType'
import { Page, Section, Container } from '../components/common'
import Meta from '../components/Meta'
import Header from '../components/Header'
import Content from '../components/Content'
import NoMatch from '../views/NoMatch'

const HeadingSection = styled(Section)`
  padding-bottom: 0;
`
const Title = styled.h1`
  margin-bottom: 0;
`
const SubTitle = styled.div`
  font-style: italic;
  font-weight: 400;
`
const Info = styled.div`
  margin-top: 1rem;
`
const InfoTitle = styled.h5`
  margin-bottom: 0;
`

const SpeciesSingle = ({ species, match, linkContentRelations, route }) => {
  const item = species.find(item => item.fields.slug === match.params.slug)
  if (!item) return <NoMatch route={route} />

  const {
    title,
    images,
    mainImage,
    speciesName,
    description,
    conservationStatus,
    category,
    familyName,
    habitat
  } = item.fields

  const type = getContentType(item)

  let imageArray = [mainImage]
  if (images) imageArray = [...imageArray, ...images]

  return (
    <Page bgWhite>
      <Helmet title={title} />
      <Meta
        title={title}
        description={description}
        url={`https://discoverspringbrook.com/${type}/${item.fields.slug}`}
      />

      <Header large images={imageArray} slider fitToContainer />

      <HeadingSection thin>
        <Container>
          <Title>{title}</Title>
          <SubTitle>{speciesName}</SubTitle>
          {familyName && (
            <Info>
              <InfoTitle>Family</InfoTitle>
              <div>{familyName}</div>
            </Info>
          )}
          {category && (
            <Info>
              <InfoTitle>
                {type === 'flora' ? 'Plant' : 'Animal'} Type
              </InfoTitle>
              <div>{category.join(', ')}</div>
            </Info>
          )}
          {habitat && (
            <Info>
              <InfoTitle>Habitat</InfoTitle>
              <div>{habitat.join(', ')}</div>
            </Info>
          )}
          {conservationStatus && (
            <Info>
              <InfoTitle>Conservation Status</InfoTitle>
              <div>{conservationStatus.join(', ')}</div>
            </Info>
          )}
        </Container>
      </HeadingSection>

      <Section thin>
        <Container>
          <Content source={linkContentRelations(description) || ''} />
        </Container>
      </Section>
    </Page>
  )
}

SpeciesSingle.propTypes = {
  species: PropTypes.array,
  match: PropTypes.object.isRequired
}

export default SpeciesSingle



// WEBPACK FOOTER //
// ./src/views/SpeciesSingle.js